import React from "react";
import { Logo } from "../logo";
import { LogoVideo } from "../logo-video";

function AuthProcessHeader({
  heading,
  subHeading,
  useLogo = true,
}: {
  heading: string;
  subHeading?: string;
  useLogo?: boolean;
}) {
  return (
    <div className="flex flex-col items-center justify-start lg:justify-center">
      {useLogo && (
        <>
          {/* Animated SVG for Mobile Screens */}
          <div className="block lg:hidden mt-2">
            <LogoVideo className="text-primary-500" />
          </div>

          {/* Static Logo for Desktop Screens */}
          <div className="hidden lg:block">
            <Logo className="text-primary-500 text-4xl" />
          </div>
        </>
      )}

      <div className="flex flex-col gap-2 text-center">
        <h1 className="font-medium text-2xl md:text-3xl mt-2">{heading}</h1>
        {subHeading && (
          <p className="text-center text-sm md:text-base text-secondary-text-500">
            {subHeading}
          </p>
        )}
      </div>
    </div>
  );
}

export default AuthProcessHeader;